import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useAppContext } from "@components/Provider";
import DealsPageBooks from "@components/DealsPage/DealsPageBooks";

import "./DealsCarousel.css";

const DealsCarousel = (props) => {
  const { title, footer, deals, hideEBBNl } = props;
  let { retailerCookie } = useAppContext();

  return (
    <div
      className={[
        "carousel-container",
        "deals-carousel",
        hideEBBNl ? "deals-carousel-hide" : "",
      ].join(" ")}
      style={{ "--dots-display": deals?.length > 1 ? "inline-block" : "none" }}
    >
      <h3 className="deals-carousel_title">{title}</h3>
      <Carousel infiniteLoop showStatus={false} showArrows={false} showThumbs={false}>
        {deals && deals.length > 0
          ? deals.map((book, idx) => (
              <DealsPageBooks
                key={idx}
                dealsPageBookProps={{
                  ...book.props,
                  renderDescription: false,
                  renderPreview: false,
                  renderOnSale: true,
                  renderPrimaryAuthors: true,
                  titleText: title,
                }}
                preferredRetailer={retailerCookie}
              />
            ))
          : null}
      </Carousel>
      {footer ? (
        <div className="carousel-footer">
          <h4>{footer?.title}</h4>
          {footer.link ? (
            <a target="_blank" rel="noopener noreferrer" href={`${footer?.link?.url}`}>
              <span className="carousel-discover-text">{footer?.link?.text}</span>
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default DealsCarousel;
